import { render, staticRenderFns } from "./index.vue?vue&type=template&id=54a1b95d&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=54a1b95d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a1b95d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/.jenkins/workspace/web-douhua-mcn-pc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54a1b95d')) {
      api.createRecord('54a1b95d', component.options)
    } else {
      api.reload('54a1b95d', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=54a1b95d&scoped=true", function () {
      api.rerender('54a1b95d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/directUpload/index.vue"
export default component.exports